const toolsInfo = [
  {
    ToolName: "VT",
    AlternateToolName: "VT",
    DisplayName: "VT",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI10",
    AlternateToolName: "TI10, TI10 FC",
    DisplayName: "TI10",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI25",
    AlternateToolName: "TI25",
    DisplayName: "TI25",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI32",
    AlternateToolName: "TI32",
    DisplayName: "TI32",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI40",
    AlternateToolName: "TI40",
    DisplayName: "TI40",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI45",
    AlternateToolName: "TI45",
    DisplayName: "TI45",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI50",
    AlternateToolName: "TI50",
    DisplayName: "TI50",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI55",
    AlternateToolName: "TI55",
    DisplayName: "TI55",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI90",
    AlternateToolName: "TI90",
    DisplayName: "TI90",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI95",
    AlternateToolName: "TI95",
    DisplayName: "TI95",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI100",
    AlternateToolName: "TI100",
    DisplayName: "TI100",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI105",
    AlternateToolName: "TI105",
    DisplayName: "TI105",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI110",
    AlternateToolName: "TI110",
    DisplayName: "TI110",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI125",
    AlternateToolName: "TI125",
    DisplayName: "TI125",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIR105",
    AlternateToolName: "TIR105",
    DisplayName: "TIR105",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIR110",
    AlternateToolName: "TIR110",
    DisplayName: "TIR110",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIR125",
    AlternateToolName: "TIR125",
    DisplayName: "TIR125",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS10",
    AlternateToolName: "TIS10",
    DisplayName: "TIS10",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS20",
    AlternateToolName: "TIS20",
    DisplayName: "TIS20",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS40",
    AlternateToolName: "TIS40",
    DisplayName: "TIS40",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS45",
    AlternateToolName: "TIS45",
    DisplayName: "TIS45",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS50",
    AlternateToolName: "TIS50",
    DisplayName: "TIS50",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS55",
    AlternateToolName: "TIS55",
    DisplayName: "TIS55",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS60",
    AlternateToolName: "TIS60",
    DisplayName: "TIS60",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS65",
    AlternateToolName: "TIS65",
    DisplayName: "TIS65",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIS75",
    AlternateToolName: "TIS75",
    DisplayName: "TIS75",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI200",
    AlternateToolName: "TI200",
    DisplayName: "TI200",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI300",
    AlternateToolName: "TI300",
    DisplayName: "TI300",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI400",
    AlternateToolName: "TI400",
    DisplayName: "TI400",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI450",
    AlternateToolName: "TI450",
    DisplayName: "TI450",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI480",
    AlternateToolName: "TI480",
    DisplayName: "TI480",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI450P",
    AlternateToolName: "TI450P, TI450 PRO",
    DisplayName: "TI450 PRO",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI480P",
    AlternateToolName: "TI480P, TI480 PRO",
    DisplayName: "TI480 PRO",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX500",
    AlternateToolName: "TIX500",
    DisplayName: "TIX500",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX520",
    AlternateToolName: "TIX520",
    DisplayName: "TIX520",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX560",
    AlternateToolName: "TIX560",
    DisplayName: "TIX560",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX580",
    AlternateToolName: "TIX580",
    DisplayName: "TIX580",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX620",
    AlternateToolName: "TIX620",
    DisplayName: "TIX620",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX640",
    AlternateToolName: "TIX640",
    DisplayName: "TIX640",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX660",
    AlternateToolName: "TIX660",
    DisplayName: "TIX660",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TIX1000",
    AlternateToolName: "TIX1000",
    DisplayName: "TIX1000",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "TI450S",
    AlternateToolName: "TI450S",
    DisplayName: "TI450 SF6",
    ToolType: "Handheld",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "805",
    AlternateToolName: "805, 805 FC",
    DisplayName: "805 FC",
    ToolType: "Handheld",
    ToolCategory: "Vibration meters"
  },
  {
    ToolName: "368",
    AlternateToolName: "368, 368 FC",
    DisplayName: "368 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "369",
    AlternateToolName: "369, 369 FC",
    DisplayName: "369 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "374",
    AlternateToolName: "374, 374 FC",
    DisplayName: "374 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "375",
    AlternateToolName: "375, 375 FC, FLUKE 375FC, FLUKE 375 FC",
    DisplayName: "375 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "376",
    AlternateToolName: "376, 376 FC",
    DisplayName: "376 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "902",
    AlternateToolName: "902, 902 FC",
    DisplayName: "902 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "1664",
    AlternateToolName: "1664, 1664 FC",
    DisplayName: "1664 FC",
    ToolType: "Handheld",
    ToolCategory: "Installation Testers"
  },
  {
    ToolName: "1587",
    AlternateToolName: "1587, 1587 FC",
    DisplayName: "1587 FC",
    ToolType: "Handheld",
    ToolCategory: "Insulation Testers"
  },
  {
    ToolName: "1550",
    AlternateToolName: "1550, 1550 FC",
    DisplayName: "1550 FC",
    ToolType: "Handheld",
    ToolCategory: "Insulation Testers"
  },
  {
    ToolName: "1555",
    AlternateToolName: "1555, 1555 FC",
    DisplayName: "1555 FC",
    ToolType: "Handheld",
    ToolCategory: "Insulation Testers"
  },
  {
    ToolName: "1630",
    AlternateToolName: "1630, 1630 FC",
    DisplayName: "1630 FC",
    ToolType: "Handheld",
    ToolCategory: "Earth Ground Testers"
  },
  {
    ToolName: "279",
    AlternateToolName: "279, 279 FC",
    DisplayName: "279 FC",
    ToolType: "Handheld",
    ToolCategory: "Digital Multimeters"
  },
  {
    ToolName: "287",
    AlternateToolName: "287, 287 FC",
    DisplayName: "287 FC",
    ToolType: "Handheld",
    ToolCategory: "Digital Multimeters"
  },
  {
    ToolName: "289",
    AlternateToolName: "289, 289 FC",
    DisplayName: "289 FC",
    ToolType: "Handheld",
    ToolCategory: "Digital Multimeters"
  },
  {
    ToolName: "3000",
    AlternateToolName: "3000, 3000FC, FLUKE 3000FC, 3000 FC",
    DisplayName: "3000 FC",
    ToolType: "Handheld",
    ToolCategory: "Digital Multimeters"
  },
  {
    ToolName: "a3000",
    AlternateToolName: "A3000, A3000FC, FLUKE A3000FC, A3000 FC",
    DisplayName: "a3000 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "a3001",
    AlternateToolName: "A3001FC, FLUKE A3001FC, A3001 FC",
    DisplayName: "a3001 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "a3002",
    AlternateToolName: "A3002FC, FLUKE A3002FC, A3002 FC",
    DisplayName: "a3002 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "a3003",
    AlternateToolName: "A3003FC, FLUKE A3003FC, A3003 FC",
    DisplayName: "a3003 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "a3004",
    AlternateToolName: "A3004FC, FLUKE A3004FC, A3004 FC",
    DisplayName: "a3004 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "v3000",
    AlternateToolName: "V3000FC, FLUKE V3000FC, V3000 FC",
    DisplayName: "v3000 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "v3001",
    AlternateToolName: "V3001FC, FLUKE V3001FC, V3001 FC",
    DisplayName: "v3001 FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "t3000",
    AlternateToolName: "T3000FC, FLUKE T3000FC, T3000 FC",
    DisplayName: "t3000FC",
    ToolType: "Handheld",
    ToolCategory: "Clamp Meters"
  },
  {
    ToolName: "3510",
    AlternateToolName: "3510, 3510 FC",
    DisplayName: "3510 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3511",
    AlternateToolName: "3511, 3511 FC",
    DisplayName: "3511 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3520",
    AlternateToolName: "3520, 3520 FC",
    DisplayName: "3520 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3521",
    AlternateToolName: "3521, 3521 FC",
    DisplayName: "3521 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3530",
    AlternateToolName: "3530, 3530 FC",
    DisplayName: "3530 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3540",
    AlternateToolName: "3540, 3540 FC",
    DisplayName: "3540 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3550",
    AlternateToolName: "3550, 3550 FC",
    DisplayName: "3550 FC",
    ToolType: "Sensor",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3502",
    AlternateToolName: "3502, 3502 FC",
    DisplayName: "3502 FC",
    ToolType: "Gateway",
    ToolCategory: "Fixed"
  },
  {
    ToolName: "3501",
    AlternateToolName: "3501, 3501 FC",
    DisplayName: "3501 FC",
    ToolType: "Gateway",
    ToolCategory: "Semi Fixed"
  },
  {
    ToolName: "3561",
    AlternateToolName: "3561, 3561 FC",
    DisplayName: "3561 FC",
    ToolType: "Sensor",
    ToolCategory: "Fixed"
  },
  {
    ToolName: "1732",
    AlternateToolName: "1732",
    DisplayName: "1732",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "1734",
    AlternateToolName: "1734",
    DisplayName: "1734",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "1736",
    AlternateToolName: "1736",
    DisplayName: "1736",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "1738",
    AlternateToolName: "1738",
    DisplayName: "1738",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "1742",
    AlternateToolName: "1742",
    DisplayName: "1742",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "1746",
    AlternateToolName: "1746",
    DisplayName: "1746",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "1748",
    AlternateToolName: "1748",
    DisplayName: "1748",
    ToolType: "Handheld",
    ToolCategory: "PQ"
  },
  {
    ToolName: "123B",
    AlternateToolName: "123B, 123B FC",
    DisplayName: "123B FC",
    ToolType: "Handheld",
    ToolCategory: "Scope Meters"
  },
  {
    ToolName: "124B",
    AlternateToolName: "124B, 124B FC",
    DisplayName: "124B FC",
    ToolType: "Handheld",
    ToolCategory: "Scope Meters"
  },
  {
    ToolName: "125B",
    AlternateToolName: "125B, 125B FC",
    DisplayName: "125B FC",
    ToolType: "Handheld",
    ToolCategory: "Scope Meters"
  },
  {
    ToolName: "DS703",
    AlternateToolName: "DS703, DS703 FC",
    DisplayName: "DS703 FC",
    ToolType: "Handheld",
    ToolCategory: "Diagnostic Borescope"
  },
  {
    ToolName: "RSE300",
    AlternateToolName: "RSE300",
    DisplayName: "RSE300",
    ToolType: "Mounted",
    ToolCategory: "Thermal Imagers"
  },
  {
    ToolName: "RSE600",
    AlternateToolName: "RSE600",
    DisplayName: "RSE600",
    ToolType: "Mounted",
    ToolCategory: "Thermal Imagers"
  }
];

export default toolsInfo;
